import { Pencil } from "lucide-react";
import { cellText } from "@/lib/exporters";

export function ReportTable({ section, testid, onEdit }) {
  const isNum = (v) => typeof v === "number";
  const edit = onEdit && section.records;
  return (
    <div className="report-section space-y-2" data-testid={testid}>
      <h3 className="text-on-bg font-heading text-lg font-bold">{section.title}</h3>
      <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
        <table className="report-table w-full text-sm">
          <thead>
            <tr className="bg-[hsl(var(--primary))] text-left text-white">
              {section.head.map((h, i) => <th key={i} className={`whitespace-nowrap px-3 py-2.5 font-semibold ${section.moneyCols?.includes(i) ? "text-right" : ""}`}>{h}</th>)}
              {edit && <th className="no-print px-3 py-2.5" />}
            </tr>
          </thead>
          <tbody>
            {section.body.length === 0 && (
              <tr><td colSpan={section.head.length + (edit ? 1 : 0)} className="px-3 py-6 text-center text-slate-500">No records for these filters.</td></tr>
            )}
            {section.body.map((row, r) => (
              <tr key={r} className={`border-t border-slate-100 ${section.strong?.includes(r) ? "bg-amber-50/70 font-bold" : "odd:bg-white even:bg-[hsl(var(--sand))]"}`}>
                {row.map((v, i) => (
                  <td key={i} className={`px-3 py-2 ${isNum(v) ? "whitespace-nowrap text-right font-mono" : "whitespace-pre"}`}>{cellText(section, i, v)}</td>
                ))}
                {edit && <td className="no-print px-2 py-1 text-right"><button type="button" onClick={() => onEdit(section.kind, section.records[r])} className="rounded p-1.5 text-slate-500 hover:bg-slate-100 hover:text-slate-900" aria-label="Edit record" data-testid={`report-edit-${section.kind}-${section.records[r].id}`}><Pencil className="h-4 w-4" /></button></td>}
              </tr>
            ))}
          </tbody>
          {section.foot && (
            <tfoot>
              <tr className="border-t-2 border-slate-300 bg-amber-50 font-bold">
                {section.foot.map((v, i) => <td key={i} className={`px-3 py-2.5 ${isNum(v) ? "whitespace-nowrap text-right font-mono" : ""}`}>{cellText(section, i, v)}</td>)}
                {edit && <td className="no-print" />}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
